import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { forumApi } from '../../api/forum';
import { formatRelativeTime } from '../../utils/relativeTime';
import HrnbLoader from '../controls/HrnbLoader';
import '../../css/components/PopularPosts.css';

/**
 * Виджет популярных постов в сайдбаре форума
 * Показывает топ-3 постов по лайкам за последние 7 дней
 */
export default function PopularPosts() {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchPopular();
    }, []);

    const fetchPopular = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await forumApi.listPosts({
                page: 0,
                size: 30,
                sortBy: 'likes',
                direction: 'DESC',
            });
            const allPosts = data.content || data.posts || data || [];

            const weekAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
            const weeklyPosts = allPosts
                .filter(p => {
                    const created = new Date(p.createdAt).getTime();
                    return !isNaN(created) && created >= weekAgo;
                })
                .slice(0, 3);

            setPosts(weeklyPosts);
        } catch (err) {
            console.warn('[PopularPosts] Failed to fetch:', err.message);
            setError('Не удалось загрузить');
            setPosts([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="popular-posts">
                <h5 className="popular-posts-title">Популярное за неделю</h5>
                <div className="popular-posts-loading"><HrnbLoader size="sm" /></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="popular-posts">
                <h5 className="popular-posts-title">Популярное за неделю</h5>
                <div className="sidebar-widget-error">
                    <span className="sidebar-widget-error-text">{error}</span>
                    <button className="sidebar-widget-retry" onClick={fetchPopular}>↻ Повторить</button>
                </div>
            </div>
        );
    }

    if (posts.length === 0) return null;

    return (
        <div className="popular-posts">
            <h5 className="popular-posts-title">Популярное за неделю</h5>
            <div className="popular-posts-list">
                {posts.slice(0, 3).map((post, index) => {
                    const authorName = post.author
                        ? (typeof post.author === 'string' ? post.author : (post.author.displayName || post.author.username || ''))
                        : '';
                    return (
                        <div
                            key={post.id}
                            className="popular-posts-item"
                            onClick={() => {
                try {
                    sessionStorage.setItem('hrnb_forum_from_forum', 'true');
                } catch (e) { /* ignore */ }
                navigate(`/forum/posts/${post.id}`);
            }}
                        >
                            <span className="popular-posts-rank">{index + 1}</span>
                            <div className="popular-posts-item-body">
                                <span className="popular-posts-item-title">{post.title}</span>
                                <span className="popular-posts-item-meta">
                                    {authorName && <span>{authorName}</span>}
                                    <span>{formatRelativeTime(post.createdAt)}</span>
                                </span>
                                <span className="popular-posts-item-stats">
                                    👍 {post.likes || post.likeCount || 0} · 💬 {post.commentCount ?? post.commentsCount ?? post.comments ?? 0}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}